/**
 * Should be moved to app.common.
 *
 * Will be migrated to store settings online. Either AWS or IB.
 */

const LAST_ACCOUNT = '.lastaccount';
const PERFORMANCE_WIDGET_KEY = '.pw-period';
const PORTFOLIO_VIEW = '.pmview';
const SHOW_VIRTUAL_FX = '.show-virtual-fx';
const SHOW_IN_BASE = '.show-in-base';
const MO_INDEX_CHART = '.mo-index-chart';
const MO_PERFORMANCE_REGION = '.mo-performance-region';
const MO_GAINERS_LOSERS_REGION = '.mo-gainers-losers-region';
const MO_MARKET_SCANNER_REGION = '.mo-market-scanner-region';
const SHOW_TRADE_NOTIFICATION = '.show-trade-notification';
const PRIVACY_MODE = '.privacy-mode';
const HIDE_GETTING_STARTED = '.hide-getting-started';
const NOTIFICATION_PREFS = '.notification-prefs';
const RECENT_SEARCH = '.recent-search';
const TELEMETRY_SSTM = '.telemetry-sstm';
const PERFORMANCE_CHART_SELECTION = '.performance-chart-selection';
const TELEMETRY_COMPONENTS = '.telemetry-components';
const PREVIOUS_ROUTE = '.previous-route'

function store_(key, value, cb) {
    const username = window.username;
    const realKey = username + key;
    localStorage.setItem(realKey, value);
    if (cb) cb(true);
}

function retrieve_(key, cb, json = false) {
    const username = window.username;
    const realKey = username + key;
    if (cb) {
        cb(json ? JSON.parse(localStorage.getItem(realKey)) : localStorage.getItem(realKey));
    }
}

function remove_(key) {
    const username = window.username;
    const realKey = username + key;
    if (realKey) {
        localStorage.removeItem(realKey);
    }
}


export const Settings = {

    get(key, def) {
        return new Promise((resolve, reject) => {
            const username = window.username;
            if (!username) {
                reject('no username');
            } else {
                const obj = localStorage.getItem(username + '.' + key);
                if ($build.mode == 'development' && process.env.DEBUG_STORE) {
                    console.debug('settings:get', username, key, obj);
                }
                if (obj === null || obj === undefined) {
                    // if defaut value is provided, store it in local storage and return same
                    if (def !== null && def !== undefined) {
                        if (typeof value === 'object') {
                            localStorage.setItem(username + '.' + key, JSON.stringify(def));
                        } else {
                            localStorage.setItem(username + '.' + key, def);
                        }
                        resolve(def);
                    } else {
                        reject('null');
                    }
                } else {
                    let ret = obj;
                    try {
                        ret = JSON.parse(obj);
                    } catch(e) {
                        // noop
                    }
                    resolve(ret);
                }
            }
        });
    },
    store(key, value) {
        const username = window.username;
        return new Promise((resolve, reject) => {
            if (!username) {
                reject('no username');
            } else {
                if ($build.mode == 'development' && process.env.DEBUG_STORE) {
                    console.debug('settings:store', username, key, value);
                }
                if (typeof value === 'object') {
                    localStorage.setItem(username + '.' + key, JSON.stringify(value));
                } else {
                    localStorage.setItem(username + '.' + key, value);
                }
                resolve(value);
            }
        });
    },

    getPortfolioView: (callback) => {
        retrieve_(PORTFOLIO_VIEW, callback);
    },

    savePortfolioView: (view, callback = null) => {
        store_(PORTFOLIO_VIEW, view, callback);
    },

    getAccountSelection: (callback) => {
        retrieve_(LAST_ACCOUNT, callback, true);
    },

    saveAccountSelection: (account, callback = null) => {
        store_(LAST_ACCOUNT, JSON.stringify(account), callback);
    },

    getPerformanceWidgetPeriod: (callback = null) => {
        retrieve_(PERFORMANCE_WIDGET_KEY, callback, false);
    },

    savePerformanceWidgetPeriod: (val) => {
        store_(PERFORMANCE_WIDGET_KEY, val);
    },

    getShowVirtualFX: (callback = null) => {
        retrieve_(SHOW_VIRTUAL_FX, callback, false);
    },

    saveShowVirtualFX: (val) => {
        store_(SHOW_VIRTUAL_FX, val);
    },

    getShowInBase: (callback = null) => {
        retrieve_(SHOW_IN_BASE, callback, false);
    },

    saveShowInBase: (val) => {
        store_(SHOW_IN_BASE, val);
    },

    /**
     * Market Overview: Index Chart
     */
    getIndexChartData: (callback = null) => {
        retrieve_(MO_INDEX_CHART, callback, true);
    },

    saveIndexChartData: (val) => {
        store_(MO_INDEX_CHART, val);
    },

    /**
     * Market Overview: Performance By Sector
     */
    getPerformanceRegion: (callback = null) => {
        retrieve_(MO_PERFORMANCE_REGION, callback, false);
    },

    savePerformanceRegion: (val) => {
        store_(MO_PERFORMANCE_REGION, val);
    },

    /**
     * Market Overview: Gainers & Losers
     */
    getGainersLosersRegion: (callback = null) => {
        retrieve_(MO_GAINERS_LOSERS_REGION, callback, false);
    },

    saveGainersLosersRegion: (val) => {
        store_(MO_GAINERS_LOSERS_REGION, val);
    },

    /**
     * Market Overview: Market Scanner
     */
    getMarketScannerRegion: (callback = null) => {
        retrieve_(MO_MARKET_SCANNER_REGION, callback, false);
    },

    saveMarketScannerRegion: (val) => {
        store_(MO_MARKET_SCANNER_REGION, val);
    },

    getShowTradeNotification: (callback = null) => {
        retrieve_(SHOW_TRADE_NOTIFICATION, callback, false);
    },

    saveShowTradeNotification: (val) => {
        Settings.store(SHOW_TRADE_NOTIFICATION, val);
    },

    getHideGettingStarted: (callback = null) => {
        retrieve_(HIDE_GETTING_STARTED, callback, false);
    },

    saveHideGettingStarted: (val) => {
        store_(HIDE_GETTING_STARTED, val);
    },

    getNotificationPrefs: (callback = null) => {
        retrieve_(NOTIFICATION_PREFS, callback, true);
    },

    /**
     * Contains key-value pair where key is notification id and value is boolean.
     * If value is true for the key, notification for that id should not be displayed
     */
    saveNotificationPrefs: (val) => {
        store_(NOTIFICATION_PREFS, val);
    },

    getPrivacyMode: (callback = null) => {
        retrieve_(PRIVACY_MODE, callback, false);
    },

    savePrivacyMode: (val) => {
        store_(PRIVACY_MODE, val);
    },

    saveRecentSearch: (val) => {
        store_(RECENT_SEARCH, val);
    },

    getRecentSearch: (callback = null) => {
        retrieve_(RECENT_SEARCH, callback, false);
    },

    saveTelemetrySstm: (val) => {
        store_(TELEMETRY_SSTM, val);
    },

    getTelemetrySstm: (callback = null) => {
        retrieve_(TELEMETRY_SSTM, callback, false);
    },

    savePerfChartSelection: (val) => {
        store_(PERFORMANCE_CHART_SELECTION, val);
    },

    getPerfChartSelection: (callback = null) => {
        retrieve_(PERFORMANCE_CHART_SELECTION, callback, false);
    },

    saveTelemetryComponents: (val) => {
        store_(TELEMETRY_COMPONENTS, val);
    },

    getTelemetryComponents: (callback = null) => {
        retrieve_(TELEMETRY_COMPONENTS, callback, false);
    },

    savePreviousRoute: (val) => {
        store_(PREVIOUS_ROUTE, JSON.stringify(val));
    },

    getPreviousRoute: (callback = null) => {
        retrieve_(PREVIOUS_ROUTE, callback, true);
        remove_(PREVIOUS_ROUTE);
    }
}
